import {FormikConfig} from 'formik';

import utils from '@utils';

export const main: Pick<FormikConfig<any>, 'validate'>['validate'] = (
  values: any
) => {
  const errors: any = {};

  if (!values.name) {
    errors.name = '名前は必須入力です';
  }
  utils.validate.email(errors, values);
  if (!values.message) {
    errors.message = 'お問い合わせ内容は必須入力です';
  }

  return errors;
};
